module.exports = __webpack_public_path__ + "static/2-52e8e4b4f92dbe56704be8089d5bfc4f.jpg";